import type { Breadcrumb } from "@sentry/react";

const URL_PARSE_BASE = "https://signed-url.invalid";
const SIGNATURE_QUERY_PARAMETER = "x-amz-signature";

export function isSignedStorageUrl(url: string): boolean {
    try {
        const parsed = new URL(url, URL_PARSE_BASE);
        return Array.from(parsed.searchParams.keys()).some(
            (key) => key.toLowerCase() === SIGNATURE_QUERY_PARAMETER
        );
    } catch {
        return false;
    }
}

export function redactSignedStorageUrl(url: string): string {
    if (!isSignedStorageUrl(url)) return url;

    const queryStart = url.indexOf("?");
    return queryStart === -1 ? url : url.slice(0, queryStart);
}

export function shouldCreateSentryRequestSpan(url: string): boolean {
    return !isSignedStorageUrl(url);
}

export function redactSignedStorageBreadcrumb(
    breadcrumb: Breadcrumb
): Breadcrumb {
    if (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch") {
        return breadcrumb;
    }

    const url = breadcrumb.data?.url;
    if (typeof url !== "string") return breadcrumb;

    const redactedUrl = redactSignedStorageUrl(url);
    if (redactedUrl === url) return breadcrumb;

    return {
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            url: redactedUrl,
        },
    };
}
